// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".referral-service-form-card__header .ui-card-header__title{width:100%}.referral-service-form-card .referral-service-card-title{font-family:var(--font-heavy);font-size:12px;text-transform:uppercase;letter-spacing:1px;color:var(--color-body-grey)}", ""]);
// Exports
module.exports = exports;
